<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista comprobantes</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/facturacion/comprobantes/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Nuevo comprobante </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid">
                <div class="input-group" style="width: 105%;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt"></i>
                    </span>
                  </span>
                  <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Comprobante</th>
                  <!-- <th>Venta asoc.</th> -->
                  <th>Oficina</th>
                  <th>Envío</th>
                  <th>Cliente</th>
                  <th>Moneda</th>
                  <th>Total</th>
                  <th>Fecha</th>
                  <th class="text-center">E.Sunat<span data-toggle="tooltip"
                      data-placement="right" data-original-title="Estado del comprobante respuesta facturador Sunat"><i
                        class="fas fa-info-circle f-s-12 m-l-5"></i></span></th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr [ngClass]="{'text-danger': item.date_repayment != null }"
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      {{item.typevoucher}}
                      <p class="f-s-12 m-b-0">{{item.nro_voucher}}</p>
                    </td>
                    <td>
                      {{item.branchoffice_data.description}}
                      <ng-container *ngIf="item.branchoffice_data.ruc != null">
                        <p class="f-s-10 m-b-0">{{item.branchoffice_data.ruc}}</p>
                      </ng-container>
                    </td>
                    <!-- <td>
                      <a class="grid__link info">
                        {{item.sale_code}}
                      </a>
                    </td> -->
                    <td>
                      <ng-container *ngIf="item.billing_external_id == null">
                        <span class="badge badge-warning f-s-10">Pendiente</span>
                      </ng-container>
                      <ng-container *ngIf="item.billing_external_id != null">
                        <span class="badge badge-info f-s-10">Enviado</span>
                      </ng-container>
                    </td>
                    <td>
                      <p class="m-b-0">{{item.client_data.fullname}}</p>
                      <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} : {{item.client_data.document}}</p>
                    </td>
                    <td>{{item.currency.description}}</td>
                    <td>{{item.amount}}</td>
                    <td>
                      {{item.date_movement}}
                    </td>
                    <td class="text-center">
                      <ng-container *ngIf="item.billing_external_id != null">
                    
                        <!-- ✅ Factura generada correctamente -->
                        <ng-container *ngIf="item.billing_response_array?.response">
                          <!-- Como response es un objeto, solo verificamos si existe -->
                          <button
                            style="padding: 3px 6px;"
                            type="button"
                            class="btn btn-sm m-l-5 f-s-12"
                            data-html="true"
                            data-container="body"
                            data-toggle="popover"
                            data-placement="right"
                            [attr.data-content]="
                              '<div>
                                <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Estado</span>: 
                                  <span class=\'bold f-s-9 badge ' + item.billing_response_array.state_type.bg_class + '\'>'
                                    + item.billing_response_array.data.state_type_description +
                                  '</span>
                                </p>
                                <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Código</span>: '
                                  + item.billing_response_array.response.code + '</p>
                                <p class=\'m-b-0 f-s-10\'><span class=\'bold\'>Descripción</span>: '
                                  + item.billing_response_array.response.description + '</p>
                              </div>'
                            "
                          >
                            <span class="badge {{item.billing_response_array.state_type.bg_class}}">{{item.billing_response_array.data.state_type_description}}</span><i class="fas fa-info-circle m-l-5"></i>
                          </button>
                        </ng-container>
                    
                        <!-- ✅ Documento dado de baja -->
                        <ng-container *ngIf="item.billing_unsubscribe != null">
                          <ng-container *ngIf="item.billing_unsubscribe_array?.response">
                            <button
                              style="padding: 3px 6px;"
                              type="button"
                              class="btn btn-outline-danger btn-sm m-l-5 f-s-12"
                              data-html="true"
                              data-container="body"
                              data-toggle="popover"
                              data-placement="right"
                              [attr.data-content]="
                                '<div>
                                  <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Estado</span>: 
                                    <span class=\'bold f-s-9 badge badge-danger m-t-10\'>De baja</span>
                                  </p>
                                  <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Código</span>: '
                                    + item.billing_unsubscribe_array.response.code + '</p>
                                  <p class=\'m-b-0 f-s-10\'><span class=\'bold\'>Descripción</span>: '
                                    + item.billing_unsubscribe_array.response.description + '</p>
                                </div>'
                              "
                            >
                              <i class="fas fa-list-alt"></i>
                            </button>
                          </ng-container>
                        </ng-container>
                    
                      </ng-container>
                    
                      <!-- Sin documento -->
                      <ng-container *ngIf="item.billing_external_id == null">
                        -
                      </ng-container>
                    </td>
                    <td class="text-center">
                      <ng-container *ngIf="item.date_repayment == null">
                        <ng-container *ngIf="item.is_from_billing">
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                            href="/{{branchofficeSlug}}/api/print/billing/document/voucher/{{item.id}}"
                            *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id">
                            <i class="fas fa-print f-s-16"></i>
                          </a>
                        </ng-container>
                        <ng-container *ngIf="!item.is_from_billing">
                          <ng-container *ngIf="item.booking_id == null">
                            <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                              href="/{{branchofficeSlug}}/api/print/billing/document/{{item.id}}"
                              *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                              <i class="fas fa-print f-s-15 pointer text-warning m-r-10 m-b-10"></i>
                            </a>
                          </ng-container>
                          <ng-container *ngIf="item.booking_id != null">
                            <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                              href="/{{branchofficeSlug}}/api/print/billing/document/booking/{{item.id}}"
                              *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                              <i class="fas fa-print f-s-16"></i>
                            </a>
                          </ng-container>
                        </ng-container>

                      </ng-container>
                      <ng-container *ngIf="item.billing_external_id == null">
                        <a (click)="sendVoucher(item)">
                          <i class="fas fa-upload f-s-15 pointer text-success m-r-10 m-b-10"></i>
                        </a>
                      </ng-container>
                      <ng-container *ngIf="item.date_repayment != null">
                        <span class="badge badge-danger">Anulado</span>
                        <!-- <ng-container *ngIf="item.billing_cancelled != null">
                          <ng-container *ngIf="item.billing_unsubscribe == null">
                            <button class="btn btn-warning d-inline-block f-s-9" data-toggle="tooltip"
                              data-placement="right" data-original-title="Completar anulación con Sunat"
                              style="padding: 5px ; font-weight: 600" (click)="cancelledVoucher(item, i)">
                              Enviar baja <i class="fas fa-hand-point-right"></i>
                            </button>
                          </ng-container>
                        </ng-container>
                        <div class="btn-group mo-mb-2">
                          <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-ellipsis-h"></i>
                          </button>
                          <div class="dropdown-menu" x-placement="bottom-start">
                            <a class="dropdown-item pointer" href="#">
                              <i class="fas fa-cart-arrow-down m-r-5 text-success"></i>Rehacer venta
                              <i class="fas fa-arrow-right m-l-2"></i>
                            </a>
                          </div>
                        </div> -->
                      </ng-container>

                      <ng-container *ngIf="item.date_repayment == null">
                        <div class="btn-group mo-mb-2">
                          <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-ellipsis-h"></i>
                          </button>
                          <div class="dropdown-menu" x-placement="bottom-start">
                            <ng-container *ngIf="item.billing_external_id != null">
                              <a class="dropdown-item pointer">
                                <i class="fas fa-envelope m-r-5 text-info"></i> Enviar a correo
                              </a>
                            </ng-container>
                            <ng-container *ngIf="item.billing_cancelled == null">
                              <!-- <a class="dropdown-item pointer" (click)="cancelledVoucher(item, i)">
                                <i class="far fa-trash-alt m-r-5 text-danger"></i>Anular comprobante
                              </a> -->
                              <a class="dropdown-item pointer" data-toggle="modal"
                                data-target="#openExtendsVoucherCancelled"
                                (click)="VoucherCancelledExtendsComponent.focused(item,i)">
                                <i class="far fa-trash-alt m-r-5 text-danger"></i>Anular comprobante
                              </a>
                            </ng-container>
                            <a *ngIf="item.billing_external_id != null" class="dropdown-item pointer"
                              (click)="downloadXml(item)">
                              <i class="far fa-file-code m-r-5 text-info"></i>Descargar XML
                            </a>
                          </div>
                        </div>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-voucher-cancelled-extends (onSubmitEvent)="extendsVoucherCancelled($event)"></app-voucher-cancelled-extends>
